export const es = {
  weekdays: {
    shorthand: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
    longhand: [
      "Domingo",
      "Lunes",
      "Martes",
      "Miercoles",
      "Jueves",
      "Viernes",
      "Sabado",
    ],
  },
  months: {
    shorthand: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
    longhand: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
  },
  daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  firstDayOfWeek: 0,
  ordinal: function (nth) {
    var s = nth % 100;
    if (s > 3 && s < 21) return "th";
    switch (s % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  },
  rangeSeparator: " a ",
  weekAbbreviation: "Sem",
  scrollTitle: "Desplazar para incrementar",
  toggleTitle: "Haga clic para alternar",
  amPM: ["AM", "PM"],
  yearAriaLabel: "Año",
  monthAriaLabel: "Mes",
  hourAriaLabel: "Hora",
  minuteAriaLabel: "Minuto",
  time_24hr: false,
};
export default es;
